import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { WhoIsFor } from './components/WhoIsFor';
import { Transformation } from './components/Transformation';
import { Modules } from './components/Modules';
import { ProgramShowcase } from './components/ProgramShowcase';
import { Includes } from './components/Includes';
import { Bonuses } from './components/Bonuses';
import { WhyAcademy } from './components/WhyAcademy';
import { LiveClasses } from './components/LiveClasses';
import { Community } from './components/Community';
import { RecordedClasses } from './components/RecordedClasses';
import { Comparison } from './components/Comparison';
import { TrustSection } from './components/TrustSection';
import { Teacher } from './components/Teacher';
import { Plans } from './components/Plans';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ed-black font-sans selection:bg-ed-green selection:text-ed-black" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <WhoIsFor data-id="element-4" />
        <Transformation data-id="element-5" />
        <Modules data-id="element-6" />
        <ProgramShowcase data-id="element-7" />
        <Includes data-id="element-8" />
        <Bonuses data-id="element-9" />
        <WhyAcademy data-id="element-10" />
        <LiveClasses data-id="element-11" />
        <Community data-id="element-12" />
        <RecordedClasses data-id="element-13" />
        <Comparison data-id="element-14" />
        <TrustSection data-id="element-15" />
        <Teacher data-id="element-16" />
        <Plans data-id="element-17" />
        <FAQ data-id="element-18" />
        <FinalCTA data-id="element-19" />
      </main>
      <Footer data-id="element-20" />
    </div>;
}